import { AppContext, RowItem } from '@/lib/core/types';
import { Row } from './row';
import { ApiBlockListModel, ApiBlockItemModel, IApiElementModel } from '@/services/platform/api/model';

interface ModulesRowProps {
  components?: ApiBlockListModel | undefined;
  context?: AppContext;
}

export function ModulesRow({ components, context }: ModulesRowProps) {
  if (!components?.items) return null;

  const rows: RowItem[] | null = [];
  let currentRow: RowItem | null = null;

  components.items.map((component, index) => {
    if (index === 0 && (component?.content as IApiElementModel)?.contentType !== 'row' && !currentRow) {
      currentRow = {
        row: {
          content: {
            contentType: 'row',
            properties: {
              fullWidth: true,
            },
          },
        } as ApiBlockItemModel,
        components: [],
      };
    }

    if (component?.content?.contentType === 'row') {
      if (currentRow) {
        rows.push(currentRow);
      }
      currentRow = {
        row: component,
        components: [],
      };
    } else if (currentRow) {
      currentRow.components.push(component);
    }
  });

  if (currentRow) {
    rows.push(currentRow);
  }

  return (
    <div className="relative w-full">
      {rows.map((row, rowIndex) => (
        <Row key={rowIndex} index={rowIndex} row={row} context={context} />
      ))}
    </div>
  );
}
